import { Button, Radio, Stack, Typography } from '@mui/material';

import { useVenuePlacementCreationContext } from '~providers';
import { DistributionChannel } from '~types';

type Props = {
  distributionChannel: DistributionChannel | null;
  onChangeDistributionChannel: (value: DistributionChannel | null) => void;
};

export const SelectDistributionChannelStep: React.FC<Props> = ({
  distributionChannel,
  onChangeDistributionChannel,
}) => {
  const { distributionChannelOptions } = useVenuePlacementCreationContext();

  return (
    <Stack gap={2}>
      <Typography variant="h6" fontWeight={600}>
        What Distribution Channel is this station on?
      </Typography>
      {distributionChannelOptions.map((item) => (
        <Button
          key={item.id}
          variant="outlined"
          sx={{
            borderRadius: '100px',
            justifyContent: 'space-between',
            padding: '10px 16px',
            color: 'inherit',
          }}
          onClick={() => onChangeDistributionChannel(item)}
        >
          <Typography color="text.black" variant="body1" fontWeight={500}>
            {item.name}
          </Typography>
          <Radio
            checked={distributionChannel?.id === item.id}
            sx={{ padding: 0 }}
          />
        </Button>
      ))}
    </Stack>
  );
};
